import { code } from "@spscommerce/utils";

export const SpsDescriptionListExamples = {
    basic: {
        label: "Basic Description List",
        examples: {
            basic: {
                jsx: code`
                    <SpsDl>
                        <SpsDt>Term 1</SpsDt>
                        <SpsDd>Definition</SpsDd>
                        <SpsDt>Term</SpsDt>
                        <SpsDd>Definition</SpsDd>
                        <SpsDt>
                            Term that wraps to the next line cause it's got so dang much text in it.
                        </SpsDt>
                        <SpsDd>Definition</SpsDd>
                        <SpsDt>Term</SpsDt>
                        <SpsDd>
                            Definition that has a LOOOOOOOOOOT of text in it.
                            Definition that has a LOOOOOOOOOOT of text in it.
                        </SpsDd>
                    </SpsDl>
                `
            },
            dynamic: {
                react: code`
                    function DemoComponent() {
                        const list = [
                            { term: "Term 1", definition: "Definition 1" },
                            { term: "Term 2", definition: "Definition 2" },
                            { term: "Term 3", definition: "Definition 3" },
                        ];

                        return (
                            <SpsDl>
                                {list.map((item, i) => (
                                    <React.Fragment>
                                        <SpsDt>{item.term}</SpsDt>
                                        <SpsDd>{item.definition}</SpsDd>
                                    </React.Fragment>
                                ))}
                            </SpsDl>
                        );
                    }
                `
            },
        },
    },
    advanced: {
        label: "Advanced Description List",
        examples: {
            advanced: {
                jsx: code`
                  <SpsDl>
                    <SpsDt>Term</SpsDt>
                    <SpsDd><SpsTextInput/></SpsDd>
                    <SpsDt error>Term</SpsDt>
                    <SpsDd><SpsTextInput/></SpsDd>
                    <SpsDt required>Term</SpsDt>
                    <SpsDd><SpsTextInput/></SpsDd>
                    <SpsDt required error>
                        Term that wraps to the next line cause it has so dang much text in it.
                    </SpsDt>
                    <SpsDd><SpsTextInput/></SpsDd>
                  </SpsDl>
                `
            }
        }
    },
    compact: {
        label: "Compact Description List",
        examples: {
            compact: {
                jsx: code`
                    <SpsDl compact>
                      <SpsDt>Term 1</SpsDt>
                      <SpsDd>Definition</SpsDd>
                      <SpsDt>Term</SpsDt>
                      <SpsDd>Definition</SpsDd>
                      <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>
                      <SpsDd>Definition</SpsDd>
                      <SpsDt>Term</SpsDt>
                      <SpsDd>Definition that has a LOOOOOOOOOOT of text in it. Definition that has a LOOOOOOOOOOT of text in it.
                      </SpsDd>
                    </SpsDl>
                `
            }
        }
    },
    columnWidths: {
        label: "Alternate Column Widths",
        examples: {
            wideTerms: {
                jsx: code`
                    <SpsDl wideTerms>
                     <SpsDt>Term 1</SpsDt>
                     <SpsDd>Definition</SpsDd>
                     <SpsDt>Term</SpsDt>
                     <SpsDd>Definition</SpsDd>
                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>
                     <SpsDd>Definition</SpsDd>  
                    </SpsDl>
                `
            },
            widerTerms: {
                jsx: code`
                    <SpsDl widerTerms>
                     <SpsDt>Term 1</SpsDt>
                     <SpsDd>Definition</SpsDd>
                     <SpsDt>Term</SpsDt>
                     <SpsDd>Definition</SpsDd>
                     <SpsDt>Term that wraps to the next line cause it's got so dang much text in it.</SpsDt>
                     <SpsDd>Definition</SpsDd>  
                    </SpsDl>
                `
            },
        }
    }
};
